<template>
  <section class="features-tiles section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container">
      <div class="features-tiles-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']" v-if="partners.length > 0 && gotData">
          <div
            :class="`tiles-item fade-in-${(index + 1) * 200 > 600 ? 200 : (index + 1) * 200}`"
            v-for="(partner, index) in partners"
            :key="partner.name"
            :data-reveal-delay="(index + 1) * 200 > 600 ? 200 : (index + 1) * 200"
            :data-offset="`${index + 1}`"
          >
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <c-image :src="partner.imageURL" :alt="partner.name" :width="92" :height="92" />
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-8">
                  {{ partner.name }}
                </h4>
                <p class="m-0 text-sm">
                  {{ partner.about }}
                </p>
              </div>
              <div class="features-tiles-item-footer mt-8">
                <a
                  :href="partner.website.startsWith('https://') ? partner.website : `https://${partner.website}`"
                  v-if="partner.website"
                  class="m-8"
                  target="_blank"
                >
                  <font-awesome-icon class="fa-lg" icon="globe-americas" />
                </a>
                <a
                  :href="partner.discordInvite.startsWith('https://') ? partner.discordInvite : `https://${partner.discordInvite}`"
                  v-if="partner.discordInvite"
                  class="m-8"
                  target="_blank"
                >
                  <font-awesome-icon class="fa-lg" :icon="['fab', 'discord']" />
                </a>
                <a :href="`https://twitter.com/${partner.twitter}`" v-if="partner.twitter" class="m-8" target="_blank">
                  <font-awesome-icon class="fa-lg" :icon="['fab', 'twitter']" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h4 class="reveal-scale-up" data-reveal-delay="200">No partners to display.</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js';
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue';
import CImage from '@/components/elements/Image.vue';

export default {
  name: 'CPartnersTiles',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      partners: [],
      gotData: false,
      sectionHeader: {
        title: '',
        paragraph: ''
      }
    };
  },

  async beforeCreate() {
    await this.$http.get('https://api.srvcontrol.net/partners').then(({ data }) => {
      this.partners = data;
      this.gotData = true;
    });
  }
};
</script>
